import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import About from "../components/pages/About"

const AboutPage = () => (
  <Layout>
    <SEO
      title="About"
      description="Do It Best Industrial Supply is the number one Hardware Store in Calvert Alabama, proud to be serving the local community and industry."
    />
    <About />
  </Layout>
)

export default AboutPage
